import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import locale from 'element-ui/lib/locale';
import zh from './lang/zh'
import en from './lang/en'
// import enLocale from 'element-ui/lib/locale/lang/en'
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n)
const DEFAULT_LANG = 'en'
const LOCALE_KEY = 'localeLanguage'

// const messages = {
//   en: Object.assign(en, enLocale),
//   zh: Object.assign(zh, zhLocale)
// }
const messages = {
  en,
  zh
}
//console.log(messages.zh)

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh',
  messages
})

// locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换

// 保存用户设置的语言
export const setup = lang => {
  if (lang === undefined) {
    // lang = window.localStorage.getItem(LOCALE_KEY)
    lang = window.navigator.language.toLowerCase().substr(0, 2)
    console.log('lang:', lang)
    if (messages[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }
  window.localStorage.setItem(LOCALE_KEY, lang)

  Object.keys(messages).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)

  Vue.config.lang = lang
  i18n.locale = lang
}

setup()
window.i18n = i18n// 全局
export default i18n
